import toast, { ToastOptions } from "react-hot-toast"

export class ToastService {
    success = (message: string, opt?: ToastOptions) => toast.success(message, opt)
    error = (message: string, opt?: ToastOptions) => toast.error(message, {...opt,duration:30000})
    loading = (message: string, opt?: ToastOptions) => toast.loading(message, opt)
    info = (message: string, opt?: ToastOptions) => toast(message, opt)
    dismiss = (toastId: string) => toast.dismiss(toastId)
}
export default new ToastService()